module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-next-project-1440x400-inact@2x.97cc8bf6.jpg";